
import addressMixin from '@/mixins/addressMixin.js';
import carriersMixin from '@/mixins/carriersMixin.js';
import cartMixin from '@/mixins/cartMixin.js';
import { Drawer } from 'element-ui';
export default {
  name: 'CheckoutCarriers',
  mixins: [addressMixin, carriersMixin, cartMixin],
  props: {
    carrierItems: {
      type: Array,
      default: () => [],
    },
    shippingType: {
      type: String,
      default: 'delivery',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawer: false,
      direction: 'rtl',
      pendingCarrierId: null,
      isSelectingFirst: false,
    };
  },
  computed: {
    selectedCarrier() {
      if (!this.carrierItems?.length) return null;
      
      // 1. Try to find the carrier from the checkout store (set by Express Checkout)
      const storeCarrierId = this.$store.state.checkout.checkoutCarrier?.IdCarrier;
      const fromStore = storeCarrierId 
        ? this.carrierItems.find((c) => String(c.IdCarrier) === String(storeCarrierId))
        : null;
      
      if (fromStore) return fromStore;

      // 2. Fallback to cart carrier
      const currentId = this.cartCarriers?.IdCarrier;
      const fromCart = currentId
        ? this.carrierItems.find((carrier) => String(carrier.IdCarrier) === String(currentId))
        : null;
      
      return fromCart || this.carrierItems[0];
    },
    drawerCarriers() {
      return this.carrierItems || [];
    },
  },
  mounted() {
    this.selectFirstCarrier();
  },
  methods: {
    async onCarrierSelected(carrier) {
      this.pendingCarrierId = carrier?.IdCarrier || null;
      this.$store.commit('checkout/setCarrierLoading', true);
      const first = this.$refs.selectedCarrier;
      if (first && typeof first.setCarrier === 'function') {
        try {
          // Note: we need to pass the carrier object if setCarrier supports it
          // In Card.vue it uses its own prop, so we might need to wait for props update or something.
          // Actually, selecting in drawer doesn't automatically call setCarrier on the card unless we trigger it.
        } finally {
          // Let's just use the watcher on cartCarriers which is triggered when cart updates.
        }
      }
    },
    selectFirstCarrier(retryCount = 0) {
      this.$nextTick(() => {
        if (!this.isActive || this.$store.state.checkout.isExpressSyncing) return;

        // CRITICAL: If a carrier is already set in the store (from Express), do NOT auto-select first
        if (this.$store.state.checkout.checkoutCarrier?.IdCarrier) {
          console.log('[Carriers] Skipping auto-select first: already have a choice in store');
          return;
        }

        const first = this.$refs.selectedCarrier;
        if (!first || typeof first.setCarrier !== 'function') {
          if (retryCount < 10) {
            setTimeout(() => this.selectFirstCarrier(retryCount + 1), 100);
          }
          return;
        }

        const current = this.cartCarriers;
        const needsReset =
          !current?.IdCarrier ||
          current?.IdCarrier === 'null' ||
          current?.CarrierType !== this.shippingType;

        if (needsReset) {
          this.isSelectingFirst = true;
          this.$store.commit('checkout/setCarrierLoading', true);
          first.setCarrier().finally(() => {
            this.isSelectingFirst = false;
            this.$store.commit('checkout/setCarrierLoading', false);
          });
        }
      });
    },
  },
  watch: {
    cartCarriers: {
      handler(val) {
        this.$store.commit('checkout/setCheckoutCarrier', { data: val });
        if (
          val?.IdCarrier &&
          val.IdCarrier !== 'null' &&
          this.checkoutError === this.$t('Please select a delivery option')
        ) {
          this.$store.commit('checkout/setCheckoutError', { data: null });
        }
        if (
          this.drawer &&
          this.pendingCarrierId &&
          val?.IdCarrier === this.pendingCarrierId
        ) {
          this.drawer = false;
          this.pendingCarrierId = null;
        }
      },
      deep: true,
      immediate: true,
    },
    carrierItems: {
      handler() {
        if (this.isActive) this.selectFirstCarrier();
      },
    },
    isActive: {
      handler(val) {
        if (val) this.selectFirstCarrier();
      },
      immediate: true,
    },
  },
  components: {
    Drawer,
  },
};
